/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Các keys lưu trữ trong storage trình duyệt --------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 *
 * @author admin
 * */

export const STORAGE_KEY = {
  langDefault: 'nhanhLangDefault',

  businesses: 'businesses',
  accessToken: 'nhanhAccessToken',
  userData: 'nhanhUserData',
  profileUI: 'nhanhProfileUI',
  BUSINESS_CURRENT: 'businessCurrent',
  usr: 'usr',
  localSettings: 'localSettings',

  // Toàn bộ cấu hình giao diện Ads portal gom trong 1 object (menu, sidebar, độ rộng, dark mode, màu)
  adsProfileUi: 'adsProfileUi',
  // Phiên đăng nhập Ads portal (jwt, user, DN, DN đang chọn) — xem AdsSessionService
  adsAuth: 'adsAuth',
  // sessionStorage: trang cần mở lại sau khi đăng nhập Nhanh xong
  adsReturnUrl: 'adsReturnUrl',
  // DN Super Admin mở gần đây (mở bằng link / ô tìm DN) — gợi ý ở ô chọn DN trên header
  adsRecentBusinesses: 'adsRecentBusinesses',
  // sessionStorage: lý do bị đăng xuất tự động (khoá tài khoản, phiên hết hạn...) — hiển thị sau khi trang tải lại
  logoutReason: 'logoutReason',
  // sessionStorage: jwt của phiên BE vừa bắt đầu đăng nhập Nhanh trang /signin — /auth/callback gửi lại (dev giữ phiên)
  nhanhLoginJwt: 'nhanhLoginJwt',

};


export const STORAGE_SETTING_UI = {
  posWrapperHorizontal: 'pos_wrapper_horizontal'
}
